import {db} from '@/firebase'

export default {
    getImpuestos({commit}){
        let devolver = [];
        return db.collection('impuestos').get()
        .then((res) => {
            res.forEach(doc => {
                let aux = doc.data();
                aux.id = doc.id;
                devolver.push(aux);
            });
            commit('setImpuestosArray',devolver);
        })
    },
    addImpuesto({rootState},imp){
        let id = imp.id;
        delete imp.id;
        var ref = null
        if (id){
            ref = db.collection('impuestos').doc(id).set(imp,{merge:true})
        } else {
            ref = db.collection('impuestos').add(imp)
        }
        return ref;
    },
    deleteImpuesto({},imp){
        return db.collection('impuestos').doc(imp.id).delete()
    }
}